export default __webpack_public_path__ + "img/14b9f61983d9c3468053c4ad4372596b.svg";